import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Donation } from 'donation/donation';
import { Product } from './shop.product.model';
import { ContactComponent } from 'contact/contact.component';
import { ShopCartService } from './shop.cart.service';
import { PRODUCT_ID_DIGITAL_DOWNLOAD } from './shop.config';
import { OptionService } from 'option/option.service';

@Component({
    selector: 'shop-download',
    templateUrl: './shop.download.component.html',
})
export class ShopDownloadComponent implements OnInit {
    /**
     * the formGroup for validation
     */
    @Input() form: FormGroup;

    /**
     * The current donation object
     */
    @Input() digitalDownloadDonation: Donation;

    /**
     * the current product
     */
    @Input() product: Product;

    /**
     * current widgetsize
     */
    @Input() size: string;

    /**
     * Output parameter for changing the step
     * @type {EventEmitter}
     */
    @Output() stepChange: EventEmitter<string> = new EventEmitter();

    downloadProduct: Product;

    /**
     * are the contact data mandatory or not
     */
    contactMandatory: boolean = false;

        /**
     * constructor
     * @param cartService
     * @param optionService
     */
    constructor(private cartService: ShopCartService, private optionService: OptionService) {}

    /**
     * @inheritDoc
     */
    ngOnInit(): void {
        // check if the contact data should be requested manually
        this.contactMandatory = ContactComponent.isContactMandatory();

        // create a copy of the product as a new download product
        this.downloadProduct = new Product();
        this.downloadProduct.copyData(this.product);

        // change some values 
        this.downloadProduct.id = PRODUCT_ID_DIGITAL_DOWNLOAD;
        this.downloadProduct.name = this.optionService.getOption('shop_donation_productname');
        this.downloadProduct.categories = [...this.product.categories];
        // remove the product from the cart if it is already in there
        this.cartService.removeItem(this.downloadProduct);
        // set the default donation value
        this.digitalDownloadDonation.amount = this.optionService.getOption("donation_value_default");
    }

    /**
     * start donation process
     */
    startDonation() {
        // the the price of the download product from the donation amount slider    
        this.downloadProduct.price = this.digitalDownloadDonation.amount;

        // add the download product to the donation
        this.digitalDownloadDonation.products = [];
        this.digitalDownloadDonation.products.push({
            id: this.downloadProduct.id,
            product: this.downloadProduct.name,
            productPlural: this.downloadProduct.name_plural,
            productInternalId: this.downloadProduct.internal_id,
            count: 1,
            price: this.downloadProduct.price,
            categories: this.cartService.findCategoryNames(this.downloadProduct),
            productText: this.downloadProduct.text,
            giftSender: null,
            giftReceiver: null,
            giftMessage: null,
            text: this.downloadProduct.text
        });

        if(this.contactMandatory === true) {
            this.stepChange.emit('contact-mandatory');
        }
        else {
            this.stepChange.emit(this.size === 'small' ? 'payment-select' : 'payment');
        }
    }
}
